export const isNullOrUndefinedOrEmpty = value => {
    return value === undefined || value === null || value === "";
  };
  